import styled from "styled-components";

import { fontRegular } from "../layout/font";

const Root = styled.div`
  ${fontRegular};
  background-color: var(--bg-body, ${(props) => props.theme.color.bg});
  color: var(--text-color-primary, ${(props) => props.theme.color.textDark});
  font-size: 1rem;
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  a img {
    border: 0;
  }

  /* --- Focus --- */

  /* Remove inner focus on buttons in Firefox */
  ::-moz-focus-inner {
    border: none;
  }

  /* Remove default focus outline */
  :focus {
    outline: none;
  }

  /* Add custom default focus to focusable elements */
  @supports selector(:focus-visible) {
    :where(
        a,
        button,
        input,
        select,
        textarea,
        summary,
        [role="button"]
      ):focus-visible {
      outline: 0.125rem solid var(--color-border-focus, #1959ca);
      outline-offset: var(--focus-outline-offset, 0.125rem);
    }
  }

  /* Fallback for Safari and IE which don't support :focus-visible */
  @supports not selector(:focus-visible) {
    :where(a, button, input, select, textarea, summary, [role="button"]):focus {
      outline: 0.125rem solid var(--color-border-focus, #1959ca);
      outline-offset: var(--focus-outline-offset, 0.125rem);
    }
  }
`;

export default Root;
